<template>
  <v-card
    flat
    text
  >
    <v-card-title class="py-0">
      <p class="font-weight-medium headline ma-2">
        Клієнти менеджера
      </p>

      <AddManagerClient @apply="addNewClient" />

      <v-spacer />
      <CustomTextField
        v-model="search"
        class="mr-1"
        placeholder="Пошук клієнта..."
        clearable
      />
    </v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="clients"
        :custom-sort="filteredClients"
        :items-per-page="10"
        :search="search"
        :footer-props="{
          itemsPerPageText: 'Рядків на сторінці',
          itemsPerPageAllText: 'Всі'
        }"
        dense
        no-results-text="На жаль, нічого не знайдено"
        :hide-default-footer="clients.length < 11"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.title }}</td>
            <td class="justify-end align-center">
              <v-btn
                icon
                class="mx-0"
                @click="remove(item)"
              >
                <v-icon color="grey">
                  delete_outline
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import AddManagerClient from "./AddManagerClient.vue";

export default {
  components: {
    AddManagerClient,
  },
  props: ["value"],
  data: () => ({
    clients: [],
    loading: false,
    headers: [
      {
        text: "Найменування",
        align: "left",
        value: "title",
      },
    ],
    isChanged: false,
    search: "",
  }),
  watch: {
    value: {
      handler() {
        this.clients = this.value;
      },
      immediate: true,
    },
  },
  methods: {
    remove(client) {
      const index = this.clients.findIndex(el => el.id === client.id);
      this.clients.splice(index, 1);
      this.isChanged = true;
      this.setClients();
    },
    setClients() {
      this.$emit("setClients", this.clients);
    },
    addNewClient(newClient) {
      this.clients.push({
        title: newClient.title,
        id: newClient.id,
      });
      this.isChanged = true;
      this.setClients();
    },
    filteredClients(items) {
      return items.sort((a, b) => {
        const titleA = a.title.trim();
        const titleB = b.title.trim();
        if (titleA < titleB) {
          return -1;
        }
        if (titleA > titleB) {
          return 1;
        }
        return 0;
      });
    },
  },
};
</script>
